module.exports = __webpack_public_path__ + "assets/express.dde3495b.svg";